import './../../external/@lit/reactive-element/reactive-element.js';
import './../../external/lit-html/lit-html.js';
import './../../external/lit-element/lit-element.js';
import { css as i } from './../../external/@lit/reactive-element/css-tag.js';
var PopupCss = i`
  :host {
    font-family: var(--isceco-font);
    position: relative;
  }

  slot[name='wrapper'] {
    display: inline-block;
    color: var(--isceco-color-blue-500);
    cursor: pointer;
  }

  slot[name='wrapper']:hover ~ .popup {
    display: block !important;
  }

  .popup-container {
    position: relative;
    display: inline-block;
    overflow: visible;
  }

  .popup {
    position: absolute;
    z-index: 99;
    display: none;
    min-width: 300px;
    max-width: 600px;
    box-sizing: border-box;
  }

  .popup > .triangle {
    width: 0;
    height: 0;
    position: absolute;
  }

  .content {
    background-color: var(--isceco-color-blue-500);
    padding: var(--isceco-space-200);
    border-radius: var(--isceco-space-100);
    overflow-y: auto;
    color: var(--isceco-color-white-500);
  }

  .popup p {
    margin: 0;
  }

  /* down */
  .popup.down {
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 100%);
  }

  .popup.down > .content {
    margin-top: var(--isceco-space-200);
  }

  .popup.down > .triangle {
    border-left: var(--isceco-space-200) solid transparent;
    border-right: var(--isceco-space-200) solid transparent;
    border-bottom: var(--isceco-space-200) solid var(--isceco-color-blue-500);
    bottom: calc(100% - var(--isceco-space-200));
    left: calc(50% - var(--isceco-space-200));
  }

  /* up */
  .popup.up {
    left: 50%;
    top: 0;
    transform: translate(-50%, -100%);
  }

  .popup.up > .content {
    margin-bottom: var(--isceco-space-200);
  }

  .popup.up > .triangle {
    border-left: var(--isceco-space-200) solid transparent;
    border-right: var(--isceco-space-200) solid transparent;
    border-top: var(--isceco-space-200) solid var(--isceco-color-blue-500);
    top: calc(100% - var(--isceco-space-200));
    left: calc(50% - var(--isceco-space-200));
  }

  /* left */
  .popup.left {
    left: 0;
    top: 50%;
    transform: translate(-100%, -50%);
  }

  .popup.left > .content {
    margin-right: var(--isceco-space-200);
  }

  .popup.left > .triangle {
    border-bottom: var(--isceco-space-200) solid transparent;
    border-top: var(--isceco-space-200) solid transparent;
    border-left: var(--isceco-space-200) solid var(--isceco-color-blue-500);
    top: calc(50% - var(--isceco-space-200));
    left: calc(100% - var(--isceco-space-200));
  }

  /* right */
  .popup.right {
    right: 0;
    top: 50%;
    transform: translate(100%, -50%);
  }

  .popup.right > .content {
    margin-left: var(--isceco-space-200);
  }

  .popup.right > .triangle {
    border-bottom: var(--isceco-space-200) solid transparent;
    border-top: var(--isceco-space-200) solid transparent;
    border-right: var(--isceco-space-200) solid var(--isceco-color-blue-500);
    top: calc(50% - var(--isceco-space-200));
    left: 0;
  }

  @media (max-width: 991.98px) {
    .popup > .triangle {
      border: none !important;
    }

    .popup > .content {
      margin: 0 !important;
    }

    .popup {
      position: fixed;
      z-index: 99;
      top: 50%  !important;
      left: 50%  !important;
      transform: translate(-50%, -50%)  !important;
      width: 350px;
    }
  }
`;
export { PopupCss as default };
